import { useEffect, useState } from "react";
import PaperConsentForm from "../../components/PaperConsentForm";
import { getUrlParams } from "../../utils/utils";
import useConsentFragment from "../../hooks/useConsentFragment";
import useCustomRouting from "../../hooks/useCustomRouting";
import useCollect from "../../hooks/useCollect";
import { useDispatch } from "react-redux";
import { setLoader } from "../../features/LoaderSlice";
import { Step, Steps } from "../../components/Steps";
import { PAPER_CONSENT, PAPER_CONSENT_FRAGMENT } from "../../utils/constants";
import PaperDeclaration from "../../components/PaperConsent/PaperDeclaration";

const PaperConsent = () => {
  const params = getUrlParams();
  const { getVersionInfo } = useConsentFragment();
  const [versionInfo, setVersionInfo] = useState();
  const [paperStep, setPaperStep] = useState(PAPER_CONSENT);
  const [paperForm, setPaperForm] = useState({});
  const { redirectToPath } = useCustomRouting();
  const {
    identityCollect,
    handleCollectSuccessMessage,
    handleCollectErrorMessage,
  } = useCollect();
  const dispatch = useDispatch();
  const getVersionDetails = async (obj) => {
    const { controller, scope, language } = obj;
    const data = await getVersionInfo(controller, scope, language);
    setVersionInfo(data);
  };
  useEffect(() => {
    const obj = {
      controller:
        params?.CountryCode?.toLowerCase() +
        "_" +
        params?.Division?.toLowerCase(),
      scope: "hcp",
      type: params?.SourceSystem?.toLowerCase(),
      value: params.CustomerID,
      language: params?.Language,
    };
    getVersionDetails(obj);
  }, []);

  const handleCollectCall = () => {
    dispatch(setLoader({ loading: true, label: "" }));
    identityCollect(paperForm, true, false, {}, true, true, false)
      .then((res) => {
        handleCollectSuccessMessage(res);
        dispatch(setLoader({ loading: false, label: "" }));
        const urlParams = new URLSearchParams(globalThis.location.search);
        redirectToPath(`/coco/?${urlParams}`);
      })
      .catch((error) => {
        handleCollectErrorMessage(error);
        dispatch(setLoader({ loading: false, label: "" }));
      });
  };
  return (
    <Steps currentStep={paperStep}>
      <Step id={PAPER_CONSENT}>
        <PaperConsentForm
          id="paperConsent"
          setPaperStep={setPaperStep}
          setPaperForm={setPaperForm}
          handleCollectCall={handleCollectCall}
          values={params}
          versionInfo={versionInfo}
        />
      </Step>
      <Step id={PAPER_CONSENT_FRAGMENT}>
        <PaperDeclaration
          setPaperForm={setPaperForm}
          handleCollect={handleCollectCall}
          controller_code={paperForm.controller_code}
          customer_scope={paperForm.customer_scope}
          language={paperForm.language} 
        />
      </Step>
    </Steps>
  );
};

export default PaperConsent;
